import { GENERAL_AND_APPEARANCE_SECTION_INTROS } from '@/components/Settings/settingsSectionIntros/generalAndAppearance'
import { PLAN_AND_WORKSPACE_SECTION_INTROS } from '@/components/Settings/settingsSectionIntros/planAndWorkspace'

/** @typedef {readonly [string, string]} SettingsSectionIntroLines */

/** @type {Record<string, SettingsSectionIntroLines>} */
export const SETTINGS_SECTION_INTROS = {
  ...PLAN_AND_WORKSPACE_SECTION_INTROS,
  ...GENERAL_AND_APPEARANCE_SECTION_INTROS,
}

/** @param {string} key @returns {SettingsSectionIntroLines | undefined} */
export function getSettingsSectionIntro(key) {
  return SETTINGS_SECTION_INTROS[key]
}
